import { beginnerCommonVerbs } from "./beginner-common-verbs";
import { beginnerCounting } from "./beginner-counting";
import { beginnerIntro } from "./beginner-intro";
import { QuizTemplate } from "./types";

export const guideTemplates = new Map<string, QuizTemplate>();

guideTemplates.set(beginnerIntro.slug, beginnerIntro);
guideTemplates.set(beginnerCounting.slug, beginnerCounting);
guideTemplates.set(beginnerCommonVerbs.slug, beginnerCommonVerbs);
